import React from 'react';
import styled from 'styled-components';
import { FormattedCurrency, FormattedMessage } from 'i18n';

function PriceBreakdownComponent({ price, tax }) {
  return (
    <PriceBreakdown>
      <PriceBreakdownItem>
        <FormattedMessage id={'productPrice.label'} description={'Product price'} defaultMessage={'Product price'} />
        <Price>
            <FormattedCurrency value={price-tax} />
        </Price>
      </PriceBreakdownItem>
      <PriceBreakdownItem>
        <FormattedMessage id={'totalTax.label'} description={'Total tax'} defaultMessage={'Total tax'} />
        <Price>
            <FormattedCurrency value={tax} />
        </Price>
      </PriceBreakdownItem>
      <LineSeparator/>
      <PriceBreakdownItem>
        <FormattedMessage id={'totalPrice.label'} description={'Total price'} defaultMessage={'Total price'} />
        <Price>
            <FormattedCurrency value={price} />
        </Price>
      </PriceBreakdownItem>
    </PriceBreakdown>
  );
}

export default PriceBreakdownComponent;

const PriceBreakdown = styled.div`
  font-size: 1em;
  display: flex;
  flex-direction: column;
`

const PriceBreakdownItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
`

const Price = styled.div`
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.text.default};
  font-weight: bold;
`;

const LineSeparator = styled.div`
  width: 100%;
  height: 2px;
  position: relative;
  background: ${({ theme }) => theme.colors.primary.dark};
  opacity: 0.5;
`